import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=89837dc6&scoped=true&"
import script from "./dataItem.vue?vue&type=script&lang=babel&"
export * from "./dataItem.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89837dc6",
  null
  
)

export default component.exports